import type { DagData, MaandTotalen } from '../../stores/controle-store';

interface ExportButtonProps {
  month: string;
  dagen: DagData[];
  totalen: MaandTotalen;
}

function formatNum(n: number | null): string {
  if (n === null) return '';
  return n.toFixed(2).replace('.', ',');
}

export function ExportButton({ month, dagen, totalen }: ExportButtonProps) {
  const handleExport = () => {
    const header = 'Datum;Pin SF;Pin MyPos;Pin Verschil;Mollie SF;Mollie Extern;Mollie Verschil;Refunds;Bank SF;Bank Extern;Bank Verschil;Contant Geregistreerd;Contant Gecontroleerd;Contant Envelop;Contant Verschil;Opmerking;Status';

    const rows = dagen.map(dag => {
      return [
        dag.datum,
        formatNum(dag.pin.sf),
        formatNum(dag.pin.extern),
        formatNum(dag.pin.verschil),
        formatNum(dag.ideal.sf),
        formatNum(dag.ideal.extern),
        formatNum(dag.ideal.verschil),
        formatNum(dag.refunds),
        formatNum(dag.bank.sf),
        formatNum(dag.bank.extern),
        formatNum(dag.bank.verschil),
        formatNum(dag.contant.geregistreerd),
        formatNum(dag.contant.gecontroleerd),
        formatNum(dag.contant.envelop),
        formatNum(dag.contant.verschil),
        dag.notitie?.opmerking?.replace(/;/g, ',') || '',
        dag.notitie?.status || 'open',
      ].join(';');
    });

    const totalRow = [
      'TOTAAL',
      formatNum(totalen.pin.sf),
      formatNum(totalen.pin.extern),
      formatNum(totalen.pin.verschil),
      formatNum(totalen.ideal.sf),
      formatNum(totalen.ideal.extern),
      formatNum(totalen.ideal.verschil),
      formatNum(totalen.refunds),
      formatNum(totalen.bank.sf),
      formatNum(totalen.bank.extern),
      formatNum(totalen.bank.verschil),
      formatNum(totalen.contant.geregistreerd),
      formatNum(totalen.contant.gecontroleerd),
      formatNum(totalen.contant.envelop),
      formatNum(totalen.contant.verschil),
      '',
      '',
    ].join(';');

    const csv = [header, ...rows, totalRow].join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' }); // BOM for Excel
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `controle-${month}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={handleExport}
      className="px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center gap-2"
      title="Exporteer als CSV"
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      CSV
    </button>
  );
}
